export default __webpack_public_path__ + "static/media/next.db22cf46.svg";